import InfluencerIdentityRowDetailsLocationAgeGender, {
  IInfluencerIdentityRowDetailsLocationAgeGenderProps,
} from './LocationAgeGender'

export { IInfluencerIdentityRowDetailsLocationAgeGenderProps }
export default InfluencerIdentityRowDetailsLocationAgeGender
